import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "data-card-management-component": "" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

import cardPopupContent from "./card-popup-content.vue";

import { checkCardIsRequiredForUser } from "../web-api";

import modalDialog from "../../../shared/ModalDialog.vue";
import waitComp from "./wait.vue";
import forcedTopElement from "../../../shared/forced-top-element.vue";
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bid-options-main',
  props: {
    termsLink: String,
    noSpinner: Boolean,
},
  emits: ["update:saved-card-status"],
  setup(__props, { expose: __expose, emit: __emit }) {



const cardRequired = ref<boolean>();
const waitingForDialog = ref(false);
const showPopup = ref(false);
const loading = ref(false);
const waitAttempts = ref(0);
const callbacks = ref<(() => void)[]>([]);
const savedCardStatus = computed(() => {
    return cardRequired.value ? "missing" : "ok";
});
const emit = __emit;
watch(
    () => savedCardStatus.value,
    (newValue) => {
        emit("update:saved-card-status", newValue);
    },
    {
        immediate: true,
    }
);

async function onCancelled() {
    closePopup();
    await reset();
}
function onCardFailed() {
    alert("Something went wrong");
}
async function onCardAccepted() {
    closePopup();
    await refreshCardIsRequired();
    if (cardRequired.value !== false) {
        alert("Something went wrong");
        throw new Error("Card still required after accept!?");
    }
    callcallbacks();
}

const instance = getCurrentInstance();

function callcallbacks() {
    let callback;
    while ((callback = callbacks.value.shift()) != null) {
        callback();
    }
}
async function reset() {
    cardRequired.value = undefined;
    waitingForDialog.value = false;
    showPopup.value = false;
    loading.value = false;
    waitAttempts.value = 0;
    //callbacks.value = [];
    await refreshCardIsRequired();
}
function openPopup() {
    showPopup.value = true;
}

const dialog = ref<InstanceType<typeof modalDialog>>();
function closePopup() {
    if (dialog.value != null)
        (dialog.value as unknown as { closeDialog(): void }).closeDialog();
}
function closedPopup() {
    showPopup.value = false;
}
async function refreshCardIsRequired() {
    loading.value = true;
    try {
        const response = await checkCardIsRequiredForUser();
        const data = response.data;
        cardRequired.value = data.required;
    } finally {
        loading.value = false;
    }
}

__expose({
    openPopup: exposedOpenPopup,
});

function exposedOpenPopup(
    callback: (() => void) | undefined | null = undefined
) {
    if (typeof callback === "function") {
        callbacks.value.splice(0, callbacks.value.length);
        callbacks.value.push(callback);
    }
    openPopup();
}

onMounted(async () => {
    if (instance == null) throw new Error("missing instance");
    // TODO get waitForAcceptOnCard from url
    window.$(instance.proxy.$el).data("openPopup", (callback: () => void) => {
        exposedOpenPopup(callback);
    });
    await refreshCardIsRequired();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "hidden",
      name: "saved-card-status",
      value: savedCardStatus.value
    }, null, 8 /* PROPS */, _hoisted_2),
    (loading.value && !__props.noSpinner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(waitComp)
        ]))
      : (cardRequired.value !== true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[1] || (_cache[1] = [
            _createElementVNode("input", {
              type: "hidden",
              value: "User has already card saved."
            }, null, -1 /* HOISTED */)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[2] || (_cache[2] = [
            _createElementVNode("input", {
              type: "hidden",
              value: "User has no card. Card is required."
            }, null, -1 /* HOISTED */)
          ]))),
    (showPopup.value)
      ? (_openBlock(), _createBlock(forcedTopElement, {
          key: 3,
          immediate: ""
        }, {
          default: _withCtx(() => [
            _createVNode(modalDialog, {
              onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (closedPopup())),
              immediate: "",
              ref_key: "dialog",
              ref: dialog,
              class: _normalizeClass(_ctx.$style['modal-dialog']),
              "auto-open": "",
              closeButton: true,
              opacity: 0.7
            }, {
              default: _withCtx(() => [
                _createVNode(cardPopupContent, {
                  "terms-link": __props.termsLink,
                  onCancelled: onCancelled,
                  onCardAccepted: onCardAccepted,
                  onCardFailedAccept: onCardFailed
                }, null, 8 /* PROPS */, ["terms-link"])
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["class"])
          ], undefined, true),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})